import { Box } from '@mui/material'

import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
// swipable views
import { styled } from '@mui/material/styles'
import { style } from '@mui/system'
import Close24 from '@evocolabs/icons/lib/Close24'
import Delete24 from '@evocolabs/icons/lib/Delete24'
import Download24 from '@evocolabs/icons/lib/Download24'
import Image40 from '@evocolabs/icons/lib/Image40'
import i18n from 'i18next'
import { Button, IconButton, Typography } from '@evocolabs/orkaui'
import React, { useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { pdfjs, Document, Page } from 'react-pdf'
import 'react-pdf/dist/esm/Page/TextLayer.css'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import {
  getUserId,
  uploadAudiogram,
  deleteAudiogram,
  getAudiogram
} from 'src/providers/RemotePoint.js'
import AccountPaper from '../../AccountPaper'
import CircularProgress from '@mui/material/CircularProgress'

import k from '../../../../i18n/keys'
import { useBackend } from '@/src/providers/BackendProvider'
import theme from '@/src/theme'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

const PREFIX = 'AccountAudiogram'

const classes = {
  header: `${PREFIX}-header`,
  paper: `${PREFIX}-paper`,
  layout: `${PREFIX}-layout`,
  uploadContainer: `${PREFIX}-uploadContainer`,
  uploadText: `${PREFIX}-uploadText`,
  emptyDiv: `${PREFIX}-emptyDiv`,
  btnDiv: `${PREFIX}-btnDiv`,
  btn: `${PREFIX}-btn`,
  input: `${PREFIX}-input`,
  myAudioLayout: `${PREFIX}-myAudioLayout`,
  divAlignCenter: `${PREFIX}-divAlignCenter`,
  myAudioHeader: `${PREFIX}-myAudioHeader`,
  btnDivNew: `${PREFIX}-btnDivNew`,
  backArr: `${PREFIX}-backArr`,
  dialog: `${PREFIX}-dialog`,
  uploadnewaudio: `${PREFIX}-uploadnewaudio`,
  submitButton: `${PREFIX}-submitButton`,
  uploadAudiogram: `${PREFIX}-uploadAudiogram`,
  pdfDocument: `${PREFIX}-pdfDocument`
}

function PdfViewer({ url }) {
  const [pageNumber, setPageNumber] = useState(0)
  return (
    <>
      <Document
        file={url}
        onError={(e) => console.error(e)}
        className={style.pdfDocument}
        onLoadSuccess={({ numPages }) => setPageNumber(numPages)}
      >
        <Page pageNumber={1} height={350} />
      </Document>
      <Box>
        {pageNumber !== 0 && (
          <Typography
            variant="body2"
            position="absolute"
            fontSize="8px"
            sx={{ transform: 'translate(-50%, -100%)' }}
          >
            Total: {pageNumber} pages
          </Typography>
        )}
      </Box>
    </>
  )
}

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.header}`]: {
    paddingTop: 47
  },

  [`&. ${classes.pdfDocument}`]: {
    height: '350px'
  },

  [`& .${classes.uploadAudiogram}`]: {
    textAlign: 'center',
    marginBottom: 32,
    maxHeight: '600px',
    overflow: 'hidden scroll',
    borderRadius: '8px',
    '::-webkit-scrollbar': {
      display: 'none' /* for Chrome, Safari, and Opera */
    },
    '-ms-overflow-style': 'none' /* for Internet Explorer, Edge */,
    'scrollbar-width': 'none' /* for Firefox */
  },

  [`& .${classes.paper}`]: {
    padding: '32px 10px',
    width: i18n.t(k._2),
    textAlign: i18n.t(k.CENTER)
  },

  [`& .${classes.layout}`]: {
    padding: '32px 40px',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    [theme.breakpoints.down('md')]: {
      padding: '24px 16px'
    }
  },

  [`& .${classes.uploadText}`]: {
    fontWeight: 500,
    fontSize: '18px',
    letterSpacing: '-0.5px',
    color: '#1A1A1A'
  },

  [`& .${classes.uploadContainer}`]: {
    width: '100%',
    borderRadius: 8,
    cursor: 'pointer',
    border: '1px dashed #979797',
    textAlign: i18n.t(k.CENTER),
    backgroundColor: '#F7F7F7',
    height: 350,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },

  [`& .${classes.emptyDiv}`]: {
    marginTop: 45
  },

  [`& .${classes.btnDiv}`]: {
    display: i18n.t(k.FLEX),
    justifyContent: 'center',
    marginLeft: i18n.t(k.AUTO),
    marginRight: i18n.t(k.AUTO)
  },

  [`& .${classes.btn}`]: {
    width: i18n.t(k.PX4),
    height: i18n.t(k._2),
    float: 'right'
  },

  [`& .${classes.input}`]: {
    display: i18n.t(k.NONE)
  },

  [`& .${classes.myAudioLayout}`]: {
    padding: '40px 80px'
  },

  [`& .${classes.divAlignCenter}`]: {
    marginLeft: i18n.t(k.AUTO),
    marginRight: i18n.t(k.AUTO),
    textAlign: i18n.t(k.CENTER),
    marginTop: '32px'
  },

  [`& .${classes.myAudioHeader}`]: {
    paddingLeft: 85,
    paddingTop: 30
  },

  [`& .${classes.btnDivNew}`]: {
    // width: 272,
    marginLeft: i18n.t(k.AUTO),
    marginRight: i18n.t(k.AUTO),
    marginTop: 40
  },

  [`& .${classes.backArr}`]: {
    transform: 'translateY(-50%)',
    flexShrink: '0',
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: '#D8D8D8',
    display: i18n.t(k.FLEX),
    alignItems: i18n.t(k.CENTER),
    flexDirection: i18n.t(k._),
    marginTop: 18
  },

  [`& .${classes.dialog}`]: {
    '& .MuiDialog-paper': {
      borderRadius: 12,
      borderWidth: 0,
      maxWidth: '808px'
    }
  },

  [`& .${classes.uploadnewaudio}`]: {
    width: i18n.t(k._2),
    paddingLeft: '20%',
    paddingRight: i18n.t(k._3),
    marginTop: 24,
    textAlign: i18n.t(k.RIGHT)
  },

  [`& .${classes.submitButton}`]: {
    width: i18n.t(k.PX5),
    height: i18n.t(k.PX6),
    color: '#ffffff',
    borderRadius: '30px',
    padding: '10px 4px 7px 8px',
    backgroundColor: '#415670',
    '&:hover': {
      backgroundColor: '#F9CB5A'
    },

    '&:active': {
      backgroundColor: '#DB872C'
    }
  }
}))

const AlertTypography = styled(Typography)({
  root: {
    color: 'red'
  }
})

const UploadContainer = styled(Box)({
  width: '100%',
  borderRadius: 8,
  border: '1px dashed #979797',
  textAlign: i18n.t(k.CENTER),
  backgroundColor: '#F7F7F7',
  height: 350,
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden scroll',
  '::-webkit-scrollbar': {
    display: 'none' /* for Chrome, Safari, and Opera */
  },
  '-ms-overflow-style': 'none' /* for Internet Explorer, Edge */,
  'scrollbar-width': 'none' /* for Firefox */
})

const UploadDialog = styled(Dialog)`
  & .MuiDialog-paper {
    max-width: 808px;
    width: calc(min(808px, 100% - 32px));
    border-radius: 12px;
  }
`

const DeleteDialog = styled(Dialog)`
  & .MuiDialog-paper {
    border-radius: 12px;
    width: 600px;
  }
`

function AccountAudiogram() {
  const { audiograms, setAudiograms } = useBackend()
  const [files, setFiles] = useState([])
  const [uploadOpen, setUploadOpen] = useState(false)
  const [viewOpen, setViewOpen] = useState(false)
  const [deleteOpen, setDeleteOpen] = useState(false)
  const [selectedAudiogram, setSelectedAudiogram] = useState(null)
  const [isRefreshing, setIsRefreshing] = useState(true) // dialog loading state

  const { fileRejections, getInputProps, open, acceptedFiles } = useDropzone({
    accept: 'image/png,image/jpg,image/jpeg,.pdf',
    maxFiles: 1,
    onDropAccepted: (acceptedFiles) => {
      setUploadOpen(true)
      refreshFiles(acceptedFiles)
    },
    noClick: true
  })
  useEffect(() => {
    refreshFiles(acceptedFiles)
  }, [])

  const refreshFiles = (acceptedFiles) => {
    setFiles(acceptedFiles[0])
  }

  const errorMessage =
    'Please select only one file and file type must be .jpg/.jpeg/.png/.pdf'

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <li key={file.path}>
      <ul>
        {errors.map((e) => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ))

  const uploadHandler = async () => {
    if (files.length !== 0 || fileRejectionItems.length === 0) {
      const userId = getUserId()

      const res = await uploadAudiogram(
        acceptedFiles[0],
        userId,
        'hiorka_account'
      )
      setAudiograms([res.data.data, ...audiograms])
      setUploadOpen(false)
      return res
    }
    console.error('cannot upload')
    return null
  }

  const handleDelete = async () => {
    if (selectedAudiogram) {
      try {
        await deleteAudiogram(selectedAudiogram.id)
        const updatedAudiograms = audiograms.filter(
          (a) => a.id !== selectedAudiogram.id
        )
        setAudiograms(updatedAudiograms)
        setDeleteOpen(false)
      } catch (error) {
        console.error('Error deleting audiogram:', error)
      }
    }
  }

  return (
    <Root style={{ width: '100%' }}>
      <AccountPaper style={{ backgroundColor: 'unset' }}>
        <div className={classes.layout}>
          <Box display="flex" gap={1} flexDirection="column">
            <Typography variant="T1" sx={{ mb: '8px' }}>
              Upload Audiogram
            </Typography>
            <Typography variant="body2">
              Upload your audiogram to get a holistic review of your hearing
              condition and precise adjustment to your hearing aids.
            </Typography>
          </Box>
          <Box display="flex" gap={2} flexDirection="column">
            <Box display="flex" alignItems="center" columnGap={2}>
              <Button
                size="large"
                variant={audiograms ? 'secondary' : 'primary'}
                onClick={() => {
                  open()
                }}
                sx={{ whiteSpace: 'nowrap' }}
              >
                Upload
              </Button>
              {/* upload hint */}
              <Box display="flex" flexDirection="column">
                {fileRejections.length > 0 && (
                  <AlertTypography
                    variant="h4"
                    style={{
                      fontWeight: 500,
                      fontSize: 12,
                      textAlign: 'center',
                      marginTop: '-32px',
                      color: '#F03738'
                    }}
                  >
                    {errorMessage}
                  </AlertTypography>
                )}
                <Typography variant="body2" color="#636363">
                  Upload an image or pdf
                </Typography>
              </Box>
            </Box>
            <Box
              width="100%"
              justifyContent="center"
              alignItems="center"
              display="flex"
              flexDirection="column"
            >
              <input {...getInputProps()} id="upload_audiogram_input" />
              {audiograms.map((audiogram) => (
                <AudiogramEntry
                  key={audiogram.id}
                  audiogram={audiogram}
                  selectedAudiogram={selectedAudiogram}
                  setSelectedAudiogram={setSelectedAudiogram}
                  files={files}
                  setViewOpen={setViewOpen}
                  setDeleteOpen={setDeleteOpen}
                  setIsRefreshing={setIsRefreshing}
                />
              ))}
            </Box>

            <DialogComponent
              dialogType="upload"
              openEvent={uploadOpen}
              setOpenEvent={setUploadOpen}
              setFiles={setFiles}
              files={files}
              audiograms={audiograms}
              selectedAudiogram={selectedAudiogram}
              uploadHandler={uploadHandler}
            />
            <DialogComponent
              dialogType="view"
              openEvent={viewOpen}
              setOpenEvent={setViewOpen}
              setFiles={setFiles}
              files={files}
              audiograms={audiograms}
              selectedAudiogram={selectedAudiogram}
              isRefreshing={isRefreshing}
            />

            <DeleteDialog
              open={deleteOpen}
              // onClose={() => setOpen(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: '8px',
                  right: '8px'
                }}
              >
                <IconButton onClick={() => setDeleteOpen(false)}>
                  <Close24 />
                </IconButton>
              </Box>
              <DialogTitle
                id="alert-dialog-title"
                style={{
                  padding: '24px 40px 16px 40px',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Typography variant="h4">Deleting Audiogram</Typography>
              </DialogTitle>
              <DialogContent
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '0 40px 24px 40px'
                }}
              >
                <Typography variant="body2" style={{ letterSpacing: '-0.2px' }}>
                  {i18n.t(k.ARE_YOU_SURE_YOU_WANT_TO_DELET)}
                </Typography>
              </DialogContent>
              <DialogActions style={{ padding: '0 40px 32px 40px' }}>
                <Button
                  handleClick={() => setDeleteOpen(false)}
                  size="large"
                  variant="secondary"
                >
                  {i18n.t(k.CANCEL)}
                </Button>
                <Button
                  handleClick={handleDelete}
                  size="large"
                  variant="primary"
                  style={{
                    width: '116px'
                  }}
                >
                  Yes
                </Button>
              </DialogActions>
            </DeleteDialog>
          </Box>
        </div>
      </AccountPaper>
    </Root>
  )
}

function AudiogramEntry({
  audiogram,
  selectedAudiogram,
  setSelectedAudiogram,
  files,
  setViewOpen,
  setDeleteOpen,
  setIsRefreshing
}) {
  const refreshSelectedAudiogramURL = async (audiogram) => {
    if (!audiogram) {
      console.error('No selected audiogram.')
      return
    }

    const userId = getUserId()
    if (userId) {
      try {
        const res = await getAudiogram(userId, true)
        const matchedAudiogram = res?.data?.data?.find(
          (receivedAudiogram) => receivedAudiogram.id === audiogram.id
        )

        if (matchedAudiogram && matchedAudiogram.url) {
          setSelectedAudiogram((prev) => ({
            ...prev,
            url: matchedAudiogram.url
          }))
        } else {
          console.error(
            'Matched audiogram does not have a valid URL or not found.'
          )
        }
      } catch (error) {
        console.error('Error refreshing the selected audiogram URL:', error)
      }
    }
  }

  return (
    <Box
      style={{
        backgroundColor: theme.palette.grey[100],
        borderRadius: '8px',
        width: '100%',
        padding: '16px 8px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: '4px'
      }}
      onClick={() => {
        setSelectedAudiogram(audiogram)
      }}
    >
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          cursor: 'pointer',
          minWidth: 0
        }}
        onClick={async () => {
          setViewOpen(true)
          setIsRefreshing(true)
          await refreshSelectedAudiogramURL(audiogram)
          setIsRefreshing(false)
        }}
      >
        <Image40 />
        <Box style={{ flexDirection: 'column', minWidth: 0, flex: 1 }}>
          <Box style={{ marginLeft: '8px' }}>
            <Typography
              variant="body3"
              style={{
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                overflowWrap: 'break-word'
              }}
            >
              {audiogram.file_name ? audiogram.file_name : 'Untitled Audiogram'}
            </Typography>
          </Box>
          <Typography
            variant="body2"
            style={{ marginLeft: '8px', fontSize: '0.8rem', color: 'grey' }}
          >
            {formatAudiogramDate(audiogram?.upload_time)}
          </Typography>
        </Box>
      </Box>
      <Box style={{ minWidth: '80px' }}>
        <IconButton
          onClick={() => {
            window.open(
              files ? URL.createObjectURL(files) : selectedAudiogram?.url
            )
          }}
        >
          <Download24 forceStroke="#404040" />
        </IconButton>
        <IconButton onClick={() => setDeleteOpen(true)}>
          <Delete24 />
        </IconButton>
      </Box>
    </Box>
  )
}

function DialogComponent({
  dialogType,
  openEvent,
  setOpenEvent,
  setFiles,
  files,
  audiograms,
  selectedAudiogram,
  uploadHandler,
  isRefreshing
}) {
  return (
    <UploadDialog
      open={openEvent}
      paperProps={{
        maxWidth: '808px',
        overflowX: 'hidden'
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '8px',
          right: '8px'
        }}
      >
        <IconButton
          onClick={() => {
            setOpenEvent(false)
            setFiles('')
          }}
        >
          <Close24 />
        </IconButton>
      </Box>

      {isRefreshing ? (
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            padding: '227px 40px 227px 40px'
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <DialogTitle
            style={{
              padding: '32px 40px 24px 40px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              overflow: 'hidden' // 添加这个属性确保标题内的内容不会超出容器
            }}
          >
            {dialogType === 'upload' ? (
              <Typography variant="h3">Upload Audiogram</Typography>
            ) : (
              <Typography
                variant="h4"
                style={{
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  overflowWrap: 'break-word',
                  overflow: 'hidden'
                }}
              >
                {selectedAudiogram?.file_name}
              </Typography>
            )}
          </DialogTitle>
          <DialogContent style={{ padding: '0 40px 24px 40px' }}>
            {(files?.length !== 0 || audiograms) && (
              <UploadContainer
                onClick={async () => {
                  setOpenEvent(false)
                  open()
                }}
              >
                {(files && files.type?.toLowerCase() === 'application/pdf') ||
                (audiograms && audiograms.url?.toLowerCase() === 'pdf') ? (
                  <PdfViewer
                    url={
                      (files ? URL.createObjectURL(files) : '') ||
                      audiograms?.url
                    }
                  />
                ) : (
                  <img
                    src={
                      files instanceof Blob
                        ? URL.createObjectURL(files)
                        : selectedAudiogram?.url
                    }
                    alt="audiogram"
                    style={{ height: '100%' }}
                  />
                )}
              </UploadContainer>
            )}
          </DialogContent>
          <Box
            position="absolute"
            right="44px"
            bottom={dialogType === 'upload' ? '116px' : '24px'}
          >
            <IconButton
              onClick={() => {
                window.open(
                  files ? URL.createObjectURL(files) : selectedAudiogram?.url
                )
              }}
            >
              <Download24 forceStroke="#404040" />
            </IconButton>
          </Box>
        </>
      )}

      {dialogType === 'upload' && (
        <DialogActions
          style={{
            justifyContent: 'center',
            padding: '0 0 32px 0'
          }}
        >
          <Button
            variant="primary"
            size="large"
            loadable
            handleClick={uploadHandler}
          >
            upload
          </Button>
        </DialogActions>
      )}
    </UploadDialog>
  )
}

const formatAudiogramDate = (uploadTime) => {
  const dateObj = new Date(uploadTime)
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ]
  const month = monthNames[dateObj.getMonth()]
  const date = `${month}.${String(dateObj.getDate()).padStart(
    2,
    '0'
  )}, ${dateObj.getFullYear()}`
  // const time = `${String(dateObj.getHours()).padStart(2, '0')}:${String(dateObj.getMinutes()).padStart(2, '0')}`;
  return date
}

export default AccountAudiogram
